import { Component, OnInit, ElementRef } from '@angular/core';
import {  ViewChild } from '@angular/core';

declare var jquery:any;
declare var $ :any;

import * as M from "materialize-css/dist/js/materialize";


import {GetdataService} from '../../services/getdata.service';
import {DeletedataService} from '../../services/deletedata.service';
import {AdddataService} from '../../services/adddata.service';
import {RouterModule,ActivatedRoute, Routes} from '@angular/router';

import {Http, Response, Headers} from '@angular/http';

@Component({
  selector: 'app-generaltotaleventsfront',
  templateUrl: './generaltotaleventsfront.component.html',
  styleUrls: ['./generaltotaleventsfront.component.css']
})
export class GeneraltotaleventsfrontComponent implements OnInit {
  
  EventsToBeShown;
  counter=0;
  constructor(private route: ActivatedRoute,private getdataService:GetdataService,  private deletedataService:DeletedataService, private adddataService:AdddataService, private http:Http, private elem: ElementRef) {
    setInterval(() => {
      this.refreshData();
    }, 10000);

   }

  ngOnInit() {
    this.refreshData();
  }

  sortByKey(array, key) {
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
}

  refreshData = ()=>{
    let account_id = this.route.snapshot.paramMap.get('id');
    var d = new Date();
    var currentDate = d.getTime();
    var currentDate_start = d.setHours(0);
    var currentDate_start = d.setMinutes(0);
    var currentDate_start = d.setSeconds(0);
    var currentDate_end = d.setHours(23);
    var currentDate_end = d.setMinutes(59);
    var currentDate_end = d.setSeconds(59);
 
    this.getdataService.getEventsByAccountID(account_id).subscribe((allEventsOnAccount) => {
      this.EventsToBeShown=[];
      allEventsOnAccount = this.sortByKey(allEventsOnAccount,'event_start_time');

      // //console.log(allEventsOnAccount)
      for(let i=this.counter; i<allEventsOnAccount.length ; i++)
      {
        var startDate = new Date(allEventsOnAccount[i].event_start_time).getTime() + (d.getTimezoneOffset() * 60000);
        var endDate = new Date(allEventsOnAccount[i].event_end_time).getTime() + (d.getTimezoneOffset() * 60000);
        // //console.log(allEventsOnAccount[i].event_start_time)
        if(startDate>currentDate_start && startDate<currentDate_end && endDate>currentDate)
        {
          allEventsOnAccount[i].event_start_time = startDate;
          allEventsOnAccount[i].event_end_time = endDate;
            this.EventsToBeShown.push(allEventsOnAccount[i]);
        }
      }
    
      this.counter = this.counter+8;
      if(this.counter>=this.EventsToBeShown.length)
      {
        this.counter=0;
      }
      

    },
    err=>{
      //////console.log(err);
      return false;
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/generaltotaleventsfront/generaltotaleventsfront.component.ts